<header class="w-full px-6 py-4 flex flex-col">
    <!-- Top row with Welcome and Logout -->
    <div class="flex justify-between items-start w-full">
        <div>
            <p class="text-lg text-gray-500 font-medium">Welcome,</p>
            <h2 class="text-xl font-bold text-gray-800">{{technician.name}} <span class="font-normal text-gray-500 text-lg">{{technician.phone_number}}</span></h2>
        </div>
        
        <button class="bg-green-600 -mt-1 hover:bg-green-700 text-white px-5 py-2 rounded-lg shadow-sm transition duration-300 flex items-center" (click)="logout()">
            <span>Logout</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
        </button>
    </div>
    
   
</header>